import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import log from "@/lib/log";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const frag = window.location.hash || "";
    const match = frag.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/google-session`,
          { session_id },
          { withCredentials: true }
        );
        setUser(r.data);
      } catch (e) {
        log.warn("[auth-callback] session exchange failed:", e?.message || e);
      } finally {
        // Strip fragment + navigate home
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B1020] text-slate-300" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#5B8DEF] border-t-transparent" />
        <div className="text-sm">Establishing your session…</div>
      </div>
    </div>
  );
}
